import { Injectable, signal, WritableSignal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SignalService {
  loadingSignal: WritableSignal<boolean> = signal(false);
  titleSignal: WritableSignal<string> = signal("");
  showTotalsSignal: WritableSignal<boolean> = signal(true);
  hasBeenEdited: WritableSignal<boolean> = signal(false);
  showWorkspace: WritableSignal<boolean> = signal(false);
  roleSignal: WritableSignal<string> = signal("TC");
}
